export default __webpack_public_path__ + "img/desktop.627ac29d.svg";